export default class Ajaxify {

    // Constructor
    constructor() {
        this.body = null;
    }

    // Init before frameworks
    init() {}

    // Init after frameworks
    initAfterFrameworks() {
        this.body = document.querySelector('body');

		// On page loads
		this.onPageLoads();

		if (!window.ajaxify) {
			// Set ajaxify
			this.setAjaxify();

			// Add loading class
			window.ajaxify = true;
		}
    }

	// On page loads
	onPageLoads() {
		// Remove loading class
		this.body.classList.remove('ajaxify-loading');

		// Open detail modal
		this.openDetailModal();
	}

	// Open detail modal
	openDetailModal() {
		const detail = document.querySelector('#tps-detail');

		if (detail) {
			jQuery(detail).foundation('open');
		}
	}

    // Set ajaxify (https://4nf.org/)
    setAjaxify() {
		const self = this;

		// Init
		jQuery(this.body).ajaxify({
			// Exclude links with no href
			selector : 'a[href]:not(.no-ajaxy)',
			// Exclude polls
			forms : 'form:not(.no-ajaxy):not(.gpoll)',
			// Delay to match the page loading icon
			requestDelay: 100,
			// Scroll to top
			// scrolltop: true,
			// Do not inline Google Tag Manager to prevent multiple instances
			inlineskip: 'googletagmanager',
		});

		// Fired before new Pronto request is made
		jQuery(window).on('pronto.request', function(event, eventInfo) {
			// Add loading class
			self.body.classList.add('ajaxify-loading');

			// Destroy all listeners
			window.tps.destroy();
		});

		// Fired after new Pronto request is rendered
		jQuery(window).on('pronto.render', function(event, eventInfo) {
			// var target = eventInfo.target || eventInfo.srcElement;

			// If the modal was open on the previous page, remove the Foundation class
			self.body.parentElement.classList.remove('is-reveal-open');

			// On page loads
			window.tps.onDomReadyCallback();

			// Is homepage = Scroll to the cards
			if (self.body.classList.contains('home')) {
				const cards = document.querySelector('.tps-comp-grid');

				if (cards) {
					window.scrollTo(0, cards.offsetTop);
				}
			}
		});
	}
}
